import React, { ReactNode } from 'react';
import { Alert, Box } from '@mui/material';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: string | null;
}

export class QuotaErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('QuotaDisplay エラー:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert severity="info" sx={{ mb: 2 }}>
          クォータ情報は一時的に取得できません。後でリロードしてください。
        </Alert>
      );
    }

    return this.props.children;
  }
}

export default QuotaErrorBoundary;
